var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.837,
    height: 7.768,
    viewBox: "0 0 9.837 7.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M115.679,831.449l-1.491-1.263-1.128-.958-1.11-.94a1.682,1.682,0,0,0-2.05,0l-3.728,3.161a.428.428,0,0,0,0,.676.639.639,0,0,0,.8,0l3.728-3.161a.381.381,0,0,1,.456,0l3.728,3.161a.639.639,0,0,0,.8,0,.429.429,0,0,0,0-.676Zm-4.557-1.576a.311.311,0,0,0-.392,0l-3.279,2.778a.219.219,0,0,0-.081.166v2.027a.948.948,0,0,0,1.016.862h1.623v-2.13h1.833v2.13h1.623a.948.948,0,0,0,1.016-.862v-2.027a.218.218,0,0,0-.081-.166Z",
    transform: "translate(-106.007 -827.94)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocal);
export default __webpack_public_path__ + "static/media/icon-local.784cdb91.svg";
export { ForwardRef as ReactComponent };